<template>
  <b-modal
    id="document-model-modal"
    :title="customization.title || title"
    size="xl"
    hide-footer
    scrollable
    @hidden="$emit('close')"
  >
    <LmFormBuilder
      class="px-0"
      :endpointUriwhereGetComponents="formbuilderPath"
      :endpointUriWhereGetValuesToLoadInEditMode="dataPathOnEditMode"
      :editors="editors"
      isDisabled
      isParentOnEditMode
    />
  </b-modal>
</template>

<script>
// Components
import LmFormBuilder from '@/components/LmFormBuilder'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    formbuilderPath: {
      type: String,
      required: true
    },
    dataPathOnEditMode: {
      type: String,
      required: true
    },
    editors: {
      type: Array,
      default: () => []
    },
    customization: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LmFormBuilder
  },
  methods: {
    async onPreview () {
      try {
        await this.$bvModal.show('document-model-modal')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
